import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Menu } from 'semantic-ui-react';
import Location from '../../molecules/Location';
import './Locations.css';

export default class Locations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeItem: 0,
    };
    this.handleItemClick = this.handleItemClick.bind(this);
  }

  handleItemClick(e, { index }) {
    return this.setState({ activeItem: index });
  }

  render() {
    const { addresses, color, textAlign, verticalAlign } = this.props;
    const { activeItem } = this.state;

    return (
      <Grid stackable>
        <Grid.Column
          computer={5}
          tablet={6}
          mobile={16}
          color={color}
          textAlign={textAlign}
          verticalAlign={verticalAlign}
          id="locations-location-list"
        >
          <Menu fluid vertical style={{ height: 'auto' }}>
            {addresses.map((address, index) => (
              <Menu.Item
                key={address.street}
                index={index}
                active={index === activeItem}
                onClick={this.handleItemClick}
                style={
                  index === activeItem
                    ? { backgroundColor: '#f0eded' }
                    : { backgroundColor: 'white' }
                }
              >
                <p>
                  {address.street}
                  <br />
                  {`${address.city}, ${address.state} ${address.zip}`}
                </p>
              </Menu.Item>
            ))}
          </Menu>
        </Grid.Column>
        <Grid.Column
          computer={11}
          tablet={10}
          mobile={14}
          stretched
          color={color}
          id="locations-location-map"
        >
          <Location address={addresses[activeItem]} showAddress={false} showMap />
        </Grid.Column>
      </Grid>
    );
  }
}

Locations.propTypes = {
  addresses: PropTypes.arrayOf(
    PropTypes.shape({
      street: PropTypes.string,
      city: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      zip: PropTypes.string.isRequired,
      country: PropTypes.string,
    }),
  ).isRequired,
  color: PropTypes.string,
  textAlign: PropTypes.oneOf(['left', 'center', 'right']),
  verticalAlign: PropTypes.oneOf(['bottom', 'middle', 'top']),
};

Locations.defaultProps = {
  color: null,
  textAlign: 'left',
  verticalAlign: 'middle',
};

Locations.propOptions = {};

Locations.dataPropsMap = {
  locations: ['business', 'locations'],
};
